import { CerbosSubscriptionActions, CerbosSubscriptionKind } from '@repo/cerbos-types';
import { buildAbacPrincipal, buildSubscriptionAttributes } from '../abac';
import { getDecision } from '../decision';
const checkAction = async (organization, user, action)=>{
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind: CerbosSubscriptionKind,
            id: organization.id,
            attributes: buildSubscriptionAttributes(organization)
        },
        actions: [
            action
        ]
    });
    return decision.isAllowed(action);
};
export const canViewSubscriptionKey = [
    'canViewSubscription',
    CerbosSubscriptionActions.GET_SUBSCRIPTION
].join('/');
export const canManageSubscriptionKey = [
    'canManageSubscription',
    CerbosSubscriptionActions.CAN_MANAGE_SUBSCRIPTION
].join('/');
export const getCanViewSubscription = async (organization, user)=>{
    return checkAction(organization, user, CerbosSubscriptionActions.GET_SUBSCRIPTION);
};
export const getCanManageSubscription = async (organization, user)=>{
    return checkAction(organization, user, CerbosSubscriptionActions.CAN_MANAGE_SUBSCRIPTION);
};
